import React from 'react';

/* Notification Badge Component */
export const NotificationBadge = ({ count, className = '' }) => {
  if (!count || count === 0) return null;
  
  return (
    <span className={`absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 ${className}`}>
      {count > 99 ? '99+' : count}
    </span>
  );
};

/* Hook to manage unread requests */
export const useUnreadRequests = (requests, userType) => {
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [readRequestIds, setReadRequestIds] = React.useState(() => {
    const stored = localStorage.getItem(`readRequests_${userType}`);
    return stored ? JSON.parse(stored) : [];
  });

  React.useEffect(() => {
    const targetStatus = userType === 'provider' ? 'pending' : 'accepted';
    
    const unreadRequests = requests.filter(req => {
      const status = req.status?.toLowerCase().trim();
      return status === targetStatus && !readRequestIds.includes(req.id);
    });
    
    setUnreadCount(unreadRequests.length);
  }, [requests, readRequestIds, userType]);

  const markAllAsRead = React.useCallback(() => {
    const targetStatus = userType === 'provider' ? 'pending' : 'accepted';
    const newReadIds = requests
      .filter(req => req.status?.toLowerCase().trim() === targetStatus)
      .map(req => req.id);
    
    const updatedReadIds = [...new Set([...readRequestIds, ...newReadIds])];
    setReadRequestIds(updatedReadIds);
    localStorage.setItem(`readRequests_${userType}`, JSON.stringify(updatedReadIds));
  }, [requests, readRequestIds, userType]);

  return { unreadCount, markAllAsRead };
};